import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Layout from './../components/help/Layout/Layout'
import Seo from './../components/help/Seo'
import Header from './../components/ui/Header/Header'
import Intro from './../components/ui/Intro/Intro'
import Contacts from './../components/pages/Contacts/Contacts'
import { getHrefToHome } from '../utils/getHrefToHome'

const ContactsPage = () => {
    const lang = 'hy'

    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageContact(title: { eq: "Title" }, locale: { eq: "hy" }) {
                value
            }

            titleForm: datoCmsRenshinPageContact(title: { eq: "Title form" }, locale: { eq: "hy" }) {
                value
            }

            blockTitleOne: datoCmsRenshinPageContact(title: { eq: "Block 1: Title" }, locale: { eq: "hy" }) {
                value
            }

            blockTextOne: datoCmsRenshinPageContact(title: { eq: "Block 1: Text" }, locale: { eq: "hy" }) {
                value
            }

            blockTitleTwo: datoCmsRenshinPageContact(title: { eq: "Block 2: Title" }, locale: { eq: "hy" }) {
                value
            }

            blockTextTwo: datoCmsRenshinPageContact(title: { eq: "Block 2: Text" }, locale: { eq: "hy" }) {
                value
            }

            thanksTitle: datoCmsRenshinPageContact(title: { eq: "Thanks: Title" }, locale: { eq: "hy" }) {
                value
            }

            thanksText: datoCmsRenshinPageContact(title: { eq: "Thanks: Text" }, locale: { eq: "hy" }) {
                value
            }

            social: allDatoCmsRenshinSocial(filter: { locale: { eq: "hy" } }) {
                nodes {
                    title
                    url
                }
            }

            seo: datoCmsRenshinSeo(originalId: { eq: "114097373" }, locale: { eq: "hy" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "hy" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    const photo = {
        1920: data.seo.bgDesktop?.url,
        1440: data.seo.bgDesktop?.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    return (
        <Layout lang={lang}>
            <Seo title={data.seo?.seo?.title} description={data.seo?.seo?.description} />
            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={data.seo.titleH1} photo={photo} lang={lang} />
            <Contacts data={data} lang={lang} />
        </Layout>
    )
}

export default ContactsPage
